import api from '@/api';
import getFio from '@/utils/fio';
import factory from '../factory';

export default factory({

  namespaced: true,

  state: () => ({
    loaded: {
      salesPeople: false,
      payButtons: false,
      payoutPlanSetupList: false,
      commonPayoutPlanSetupList: false,
      distributionSchemes: false,
      feeTypes: false,
      timezones: false,
    },
    loading: {
      salesPeople: false,
      payButtons: false,
      payoutPlanSetupList: false,
      commonPayoutPlanSetupList: false,
      distributionSchemes: false,
      feeTypes: false,
      timezones: false,
    },
    payButtons: [],
    rawPayButtons: [],
    payoutPlanSetupList: [],
    commonPayoutPlanSetupList: [],
    salesPeople: [],
    distributionSchemes: [],
    feeTypes: [],
    timezones: [],
    platformCommissionLevelsDefault: [],
    platformFeeDefaults: null,
  }),

  getters: {
    defaultPayoutPlan(state) {
      const defaultPlan = state.payoutPlanSetupList.find((item) => item.isDefault);

      return defaultPlan?.id ? defaultPlan : null;
    },
    defaultCommonPayoutPlan(state) {
      const defaultPlan = state.commonPayoutPlanSetupList.find((item) => item.isDefault);

      return defaultPlan?.id ? defaultPlan : null;
    },
  },

  actions: {
    async loadPayButtons({ commit }, payload) {
      commit('set', {
        loading: {
          payButtons: true,
        },
        payButtons: [],
        rawPayButtons: [],
      });

      try {
        const { data } = await api.locations.getPayButtons(payload);

        if (data) {
          commit('set', {
            loaded: {
              payButtons: true,
            },
            payButtons: data.filter((item) => item.amountList.length),
            rawPayButtons: data,
          });
        }
      } catch (e) {
        throw e;
      } finally {
        commit('set', {
          loading: {
            payButtons: false,
          },
        });
      }
    },
    async loadDefaultPayoutPlanSetupList({ commit }, payload) {
      commit('set', {
        loading: {
          payoutPlanSetupList: true,
        },
      });

      try {
        const { data } = await api.locations.getPayoutPlanSetupList(payload);

        if (data) {
          commit('set', {
            loaded: {
              payoutPlanSetupList: true,
            },
            payoutPlanSetupList: data,
          });
        }
      } catch (e) {
        throw e;
      } finally {
        commit('set', {
          loading: {
            payoutPlanSetupList: false,
          },
        });
      }
    },
    async loadCommonPayoutPlanSetupList({ commit }, payload) {
      commit('set', {
        loading: {
          payoutPlanSetupList: true,
        },
      });

      try {
        const { data } = await api.locations.getPayoutPlanSetupList(payload);

        if (data) {
          commit('set', {
            loaded: {
              commonPayoutPlanSetupList: true,
            },
            commonPayoutPlanSetupList: data,
          });
        }
      } catch (e) {
        throw e;
      } finally {
        commit('set', {
          loading: {
            commonPayoutPlanSetupList: false,
          },
        });
      }
    },
    async loadSalesPeople({ commit }) {
      commit('set', {
        loading: {
          salesPeople: true,
        },
      });

      try {
        const { data } = await api.locations.getSalesPeople();

        const salesPeople = data.map((item) => ({
          fio: getFio(item),
          ...item,
        }));

        commit('set', {
          loaded: {
            salesPeople: true,
          },
          salesPeople,
        });
      } catch (e) {
        throw e;
      } finally {
        commit('set', {
          loading: {
            salesPeople: false,
          },
        });
      }
    },
    async loadDistributionSchemes({ commit }, payload) {
      commit('set', {
        loading: {
          distributionSchemes: true,
        },
      });

      try {
        const { data } = await api.locations.getDistributionSchemes(payload);

        if (data) {
          commit('set', {
            loaded: {
              distributionSchemes: true,
            },
            distributionSchemes: data,
          });
        }
      } catch (e) {
        throw e;
      } finally {
        commit('set', {
          loading: {
            distributionSchemes: false,
          },
        });
      }
    },
    async loadFeeTypes({ commit }) {
      commit('set', {
        loading: {
          feeTypes: true,
        },
      });

      try {
        const { data } = await api.handbook.getFeeTypes();

        if (data) {
          commit('set', {
            loaded: {
              feeTypes: true,
            },
            feeTypes: data,
          });
        }
      } catch (e) {
        throw e;
      } finally {
        commit('set', {
          loading: {
            feeTypes: false,
          },
        });
      }
    },
    async loadPlatformCommissionLevels({ commit }, payload) {
      if (!payload?.countryCode || !payload?.paymentSystem) {
        return;
      }

      try {
        const { data } = await api.handbook.getPlatformCommissionLevels(payload);

        if (data) {
          commit('set', {
            platformCommissionLevelsDefault: data,
          });
        }
      } catch (e) {
        throw e;
      }
    },
    async loadPlatformFeeDefaults({ commit }, countryCode) {
      if (!countryCode) {
        return;
      }

      try {
        const { data } = await api.handbook.getPlatformFeeDefaults({ countryCode });

        if (data) {
          commit('set', { platformFeeDefaults: data });
        }
      } catch (e) {
        throw e;
      }
    },
    async loadTimezones({ commit }, payload) {
      if (!payload) {
        return;
      }

      commit('set', {
        loading: {
          timezones: true,
        },
      });

      try {
        const { data } = await api.handbook.getTimezones({ countryId: payload });

        if (data) {
          commit('set', {
            loaded: {
              timezones: true,
            },
            timezones: data,
          });
        }
      } catch (e) {
        throw e;
      } finally {
        commit('set', {
          loading: {
            timezones: false,
          },
        });
      }
    },
  },
});
